import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import dsBankApi from "service/TichHopBank/dsBankApi";
import userApi from "../../../service/userApi";
import { formatNumber } from "utils/currencyFormat";
import ReactToPrint from "react-to-print";
import { exportComponentAsPNG } from "react-component-export-image";
import AuthApi from "../../../service/AuthApi";

export const ModalXacNhanDiaChiIp = (props) => {
  const componentRef = useRef();
  const ChoPhepIpTruyCap = () => {
    AuthApi.luuDiaChiIP({ ip: props.ipLogin });
    props.onHide();
  };
  return (
    <Modal
      {...props}
      size="modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="fade modal-new modal fade text-left modal show"
      backdrop="static"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-qrcode"></i>
          </span>
          Xác nhận IP truy cập phần mềm
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group row">
          <label className="col-md-12 label-control">
            Bạn đang đăng nhập với IP: <b>{props.ipLogin}</b> bạn có muốn lưu
            địa chỉ IP này?
          </label>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        <button
          type="button"
          class="btn btn-new-main btn-closenew"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng &nbsp;
        </button>
        <button
          className="btn btn-new-main btn-checknew"
          type="submit"
          onClick={ChoPhepIpTruyCap}
        >
          <span>
            <img src="/app-assets/images/icon-save-v2-white.png" />
          </span>
          Cho phép
        </button>
      </Modal.Footer>
    </Modal>
  );
};
